var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleDrive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12770_5520)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.05842 12.4663L2.67583 13.5327C2.80412 13.7572 2.98855 13.9336 3.20504 14.0619L5.41008 10.2452H1C1 10.4937 1.06415 10.7423 1.19244 10.9668L2.05842 12.4663Z",
  fill: "#0066DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.7549L5.79496 1.93817C5.57846 2.06646 5.39404 2.24287 5.26575 2.46738L1.19244 9.52351C1.06651 9.74318 1.00017 9.99195 1 10.2452H5.41008L8 5.7549Z",
  fill: "#00AC47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7947 14.0619C13.0112 13.9336 13.1956 13.7572 13.3239 13.5327L13.5805 13.0917L14.8073 10.9668C14.9356 10.7423 14.9998 10.4937 14.9998 10.2452H10.5894L11.5278 12.0894L12.7947 14.0619Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99996 5.75489L10.205 1.93817C9.98851 1.80987 9.73994 1.74573 9.48335 1.74573H6.51657C6.25999 1.74573 6.01142 1.81789 5.79492 1.93817L7.99996 5.75489Z",
  fill: "#00832D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.59 10.2452H5.41012L3.20508 14.0619C3.42157 14.1902 3.67014 14.2543 3.92673 14.2543H12.0733C12.3299 14.2543 12.5785 14.1822 12.795 14.0619L10.59 10.2452Z",
  fill: "#2684FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7709 5.99544L10.7342 2.46738C10.606 2.24287 10.4215 2.06646 10.205 1.93817L8 5.7549L10.5899 10.2452H14.992C14.992 9.99659 14.9278 9.74802 14.7995 9.52351L12.7709 5.99544Z",
  fill: "#FFBA00"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12770_5520"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 12.5086,
  fill: "white",
  transform: "translate(1 1.74573)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleDrive);
export default ForwardRef;